import React from "react";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import LeftCustomMenu from "@layout/MainLayout/MainDrawer/LeftCustomMenu";
import { filterIcons } from "@assets/icons/CustomIcons";
import { NavLink as RouterLink } from "react-router-dom";
import ListItemButton from "@mui/material/ListItemButton";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import Collapse from "@mui/material/Collapse";
import List from "@mui/material/List";

const LeftSubMenu = ({ onClick, data, arr, open }) => {
  let dataSubMap = Object.values(data.sub);

  return (
    <>
      <ListItemButton
        onClick={() => onClick(data.no)}
        sx={{
          borderRadius: "8px",
          mb: 0.75,
          "&:hover": {
            backgroundColor: "primary.light",
            color: "primary.main",
            "& svg": {
              fill: "#4183FF",
            },
          },
        }}
      >
        <ListItemIcon>
          {filterIcons(data.eName, {
            color: `${arr[0] === data.eName ? "" : ""}`,
            fontSize: 24,
          })}
        </ListItemIcon>
        <ListItemText primary={<LeftCustomMenu>{data.name}</LeftCustomMenu>} />
        {data.open ? (
          <ExpandLess sx={{ fontSize: 24, color: "#D9D9D9" }} />
        ) : (
          <ExpandMore sx={{ fontSize: 24, color: "#D9D9D9" }} />
        )}
      </ListItemButton>
      <Collapse in={data.open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {dataSubMap.map((d, index) => {
            return d.permission ? (
              <ListItem
                key={d.link}
                disablePadding
                button
                component={RouterLink}
                to={d.link}
                sx={{
                  borderRadius: "8px",
                  mb: 0.75,
                }}
              >
                <ListItemButton
                  sx={{
                    borderRadius: "8px",
                    backgroundColor:
                      arr.length === 1
                        ? arr[0] === data.eName && d.eName === ""
                          ? "primary.light"
                          : ""
                        : arr[0] === data.eName && arr[1] === d.eName
                        ? "primary.light"
                        : "",

                    "&:hover": {
                      backgroundColor: "primary.light",
                      color: "primary.main",
                      "& p": {
                        color:
                          arr.length === 1
                            ? arr[0] === data.eName && d.eName === ""
                              ? "primary"
                              : "primary.main"
                            : arr[0] === data.eName && arr[1] === d.eName
                            ? "primary"
                            : "primary.main",
                      },
                    },
                  }}
                >
                  <ListItemText
                    inset
                    primary={
                      <LeftCustomMenu
                        color={
                          arr.length === 1
                            ? arr[0] === data.eName && d.eName === ""
                              ? "primary"
                              : "#9A9A9B"
                            : arr[0] === data.eName && arr[1] === d.eName
                            ? "primary"
                            : "#9A9A9B"
                        }
                      >
                        {d.name}
                      </LeftCustomMenu>
                    }
                  />
                </ListItemButton>
              </ListItem>
            ) : (
              <div key={d.link}></div>
            );
          })}
        </List>
      </Collapse>
    </>
  );
};

export default LeftSubMenu;
